import { createSlice } from "@reduxjs/toolkit";

export const savingsSourcesSlice = createSlice({
  name: "savingsSources",
  initialState: {
    init: false,
    data: [],
    savingsSourceData: null,
    selectedModal: null,
    categories: [],
    loading: true,
    assets: [],
    currentSavingsSourceAsset: null,
    view: "list", // "list" or "charts"
    encryptedNote: null,
  },
  reducers: {
    addSavingsSource: (state, action) => {
      state.data.push(action.payload);
    },
    addSavingsSourceAsset: (state, action) => {
      state.assets.push(action.payload);
    },
    setSavingsSources: (state, action) => {
      state.data = action.payload;
      state.init = true;
    },
    setSelectedModal: (state, action) => {
      state.selectedModal = action.payload;
    },
    setSavingsSourceData: (state, action) => {
      const { data, assets, encrypted_note } = action.payload;
      state.savingsSourceData = data;
      state.assets = assets;
      state.encryptedNote = encrypted_note || null;
    },
    updateSavingsSource: (state, action) => {
      state.savingsSourceData = action.payload;
    },
    updateSavingsSourceAsset: (state, action) => {
      const { id } = action.payload;
      const index = state.assets.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.assets[index] = action.payload;
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setCurrentSavingsSourceAsset: (state, action) => {
      state.currentSavingsSourceAsset = action.payload;
    },
    deleteSavingsSource: (state) => {
      state.data = state.data.filter(
        (item) => item.id !== state.savingsSourceData.id
      );
      state.savingsSourceData = null;
      state.encryptedNote = null;
    },
    deleteSavingsSourceAsset: (state, action) => {
      const { id } = action.payload;
      state.assets = state.assets.filter((item) => item.id !== id);
    },
    updateSavingsSourceWidget: (state, action) => {
      const { id, widget } = action.payload;
      const savingsSource = state.data.find((item) => item.id === id);
      if (savingsSource) {
        savingsSource.widget = widget;
      }
    },
    setView: (state, action) => {
      state.view = action.payload;
    },
  },
});

export const {
  addSavingsSource,
  addSavingsSourceAsset,
  setSavingsSources,
  setSavingsSourceData,
  setSelectedModal,
  setLoading,
  setCategories,
  setCurrentSavingsSourceAsset,
  deleteSavingsSource,
  deleteSavingsSourceAsset,
  updateSavingsSource,
  updateSavingsSourceWidget,
  updateSavingsSourceAsset,
  setView,
} = savingsSourcesSlice.actions;

export default savingsSourcesSlice.reducer;
